import { groupOfMcc, MCC_GROUP } from './mcc-groups.js';
export const BANK_OPERATION_KIND = {
    EXPENSE: 'expense',
    INCOME: 'income',
    TRANSFER: 'transfer',
    REFUND: 'refund',
};
const ACCOUNT_MIGRATION = [
    'списання коштів в рамках міграції рахунку',
    'зарахування коштів в рамках міграції рахунку',
];
const REFUND_PREFIXES = ['скасування.', 'повернення платежу'];
const CASH_WITHDRAWAL = 'видача готівки';
const NOT_A_PURCHASE = [MCC_GROUP.TRANSFERS, MCC_GROUP.CASH];
const PURPOSE_UNKNOWN = [MCC_GROUP.TRANSFERS, MCC_GROUP.OTHER];
const UTILITY_ABBREVIATIONS = ['осбб', 'осмд', 'жбк', 'жек', 'жэк', 'тсж'];
const UTILITY_STEMS = [
    'співвласник',
    'квартплат',
    'водоканал',
    'теплоенерго',
    'тепломереж',
    'тепловімереж',
    'теплосет',
    'тепловыесет',
    'енергозбут',
    'обленерго',
    'газзбут',
    'газопостач',
    'нафтогаз',
];
const NOT_A_LETTER = /[^\p{L}]+/gu;
const normalisedOf = (description) => description.trim().toLowerCase();
const isRefundOf = (facts) => {
    const description = normalisedOf(facts.description);
    const isNamedRefund = REFUND_PREFIXES.some((prefix) => description.startsWith(prefix));
    const isShopCode = !NOT_A_PURCHASE.includes(groupOfMcc(facts.mcc));
    return isNamedRefund || isShopCode;
};
export const isCategorisedKind = (kind) => kind === BANK_OPERATION_KIND.EXPENSE || kind === BANK_OPERATION_KIND.REFUND;
export const kindOfOperation = (facts) => {
    if (ACCOUNT_MIGRATION.includes(normalisedOf(facts.description))) {
        return BANK_OPERATION_KIND.TRANSFER;
    }
    if (facts.amountMinor < 0) {
        return BANK_OPERATION_KIND.EXPENSE;
    }
    return isRefundOf(facts) ? BANK_OPERATION_KIND.REFUND : BANK_OPERATION_KIND.INCOME;
};
const isUtilityText = (text) => {
    const normalised = normalisedOf(text);
    const words = normalised.split(NOT_A_LETTER);
    const letters = normalised.replace(NOT_A_LETTER, '');
    const hasAbbreviation = words.some((word) => UTILITY_ABBREVIATIONS.includes(word));
    return hasAbbreviation || UTILITY_STEMS.some((stem) => letters.includes(stem));
};
const namesOf = (facts) => [facts.description, facts.comment, facts.counterName].flatMap((text) => text === null ? [] : [text]);
export const groupOfOperation = (facts) => {
    const description = normalisedOf(facts.description);
    if (description.startsWith(CASH_WITHDRAWAL)) {
        return MCC_GROUP.CASH;
    }
    const group = groupOfMcc(facts.mcc);
    const isPaidToUtility = PURPOSE_UNKNOWN.includes(group) && namesOf(facts).some(isUtilityText);
    return isPaidToUtility ? MCC_GROUP.UTILITIES : group;
};
//# sourceMappingURL=bank-operation-kind.js.map